const pillar = {
  risk: '#5b8fd4',
  evidence: '#5da87a',
  trust: '#d4925e',
  ai: '#a07ad4',
};

const darkPalette = {
  mode: 'dark',
  primary: { main: '#7577e8', light: '#9294f0', dark: '#5a5cd0' },
  error: { main: '#d27373', light: '#de9090', dark: '#b85a5a' },
  warning: { main: '#d4925e', light: '#dba87a', dark: '#bc7a45' },
  success: { main: '#5da87a', light: '#78be93', dark: '#4a9066' },
  info: { main: '#5b8fd4', light: '#7aa5de', dark: '#4a7abb' },
  background: { default: '#0a0f1a', paper: '#111827', subtle: '#1e293b' },
  text: { primary: '#f1f5f9', secondary: '#94a3b8', disabled: '#475569' },
  divider: '#1e293b',
  pillar,
};

const lightPalette = {
  mode: 'light',
  primary: { main: '#5a5cd0', light: '#7577e8', dark: '#4345b5' },
  error: { main: '#b85a5a', light: '#d27373', dark: '#9e4747' },
  warning: { main: '#bc7a45', light: '#d4925e', dark: '#a06638' },
  success: { main: '#4a9066', light: '#5da87a', dark: '#3d7a56' },
  info: { main: '#4a7abb', light: '#5b8fd4', dark: '#3c669e' },
  background: { default: '#f8fafc', paper: '#ffffff', subtle: '#f1f5f9' },
  text: { primary: '#0f172a', secondary: '#64748b', disabled: '#cbd5e1' },
  divider: '#e2e8f0',
  pillar,
};

export { darkPalette, lightPalette, pillar };
